module.exports = __webpack_public_path__ + "img/set-scatter-plot.6ff86b9b.svg";